import { tickerNews } from '@/mocks/ranking';

export default function Ticker() {
  const doubled = [...tickerNews, ...tickerNews];
  return (
    <div className="relative z-10 -mt-0 flex items-center overflow-hidden bg-primary-600 py-2.5 text-background-50">
      <div className="z-10 flex shrink-0 items-center gap-1.5 bg-primary-700 px-4 py-2.5 text-xs font-bold">
        <span className="relative flex h-2 w-2">
          <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-accent-400" />
        </span>
        <span className="whitespace-nowrap">实时瓜讯</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="animate-ticker flex w-max items-center gap-10 whitespace-nowrap pl-10 text-sm">
          {doubled.map((t, i) => (
            <span key={i} className="flex items-center gap-2">
              <i className="ri-sparkling-2-line text-base leading-none text-accent-300" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}